import styled from 'styled-components'

export const Container = styled.div`
    .strong-bar-container {
        display: flex;
        flex-direction: row;
        justify-content: center;

        margin-top: 16px;

        > div {
            height: 2px;
            min-width: 100px;
            width: 100%;
            background-color: #2da853;
            margin: 0 8px 0 0;
            border-radius: 1.2px;

            :last-child {
                margin: 0;
            }
        }
    }

    .strong-bar-text {
        &&& {
            font-weight: 500;
            font-size: 14px;
        }
    }
`
export const SecurityBarContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;

    margin-top: 16px;

    > div {
        height: 2px;
        min-width: 100px;
        width: 100%;
        margin: 0 8px 0 0;
        border-radius: 1.2px;

        :last-child {
            margin: 0;
        }
    }
`
